import React, { useEffect, useState } from 'react';
import { Building2, ChevronRight, Layers } from 'lucide-react';
import { api } from '../../context/AuthContext';

const STATUS = { neu: 'Anfrage', in_bearbeitung: 'In Bearbeitung', ruhend: 'Ruhend', abgeschlossen: 'Abgeschlossen' };
const oeffnen = (nr, cid) => { localStorage.setItem('kp_mandant_ctx', nr); window.location.assign(cid ? `/portal/akten/${cid}` : '/dashboard'); };

export const AlleMandate = () => {
  const [items, setItems] = useState([]);
  const akt = localStorage.getItem('kp_mandant_ctx');
  useEffect(() => { api.get('/portal/alle-mandate').then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (items.length < 2) return null;
  return (
    <section data-testid="portal-alle-mandate">
      <h2 className="text-base md:text-lg font-serif text-[#1B3A5C] mb-3 flex items-center gap-2"><Layers className="w-4 h-4 text-[#b8893d]" /> Alle meine Mandate</h2>
      <div className="space-y-3">
        {items.map((m) => (
          <div key={m.mandanten_nr} className={`bg-white rounded-2xl border p-4 ${m.mandanten_nr === akt ? 'border-[#b8893d]/60' : 'border-gray-200'}`} data-testid={`portal-mandat-${m.mandanten_nr}`}>
            <button type="button" onClick={() => oeffnen(m.mandanten_nr)} className="w-full flex items-center gap-3 text-left" data-testid={`portal-mandat-wechseln-${m.mandanten_nr}`}>
              <span className="w-9 h-9 rounded-xl bg-[#0B1724] text-[#e0b56a] flex items-center justify-center"><Building2 className="w-4 h-4" /></span>
              <span className="flex-1 min-w-0"><span className="block text-sm font-medium text-[#1B3A5C] truncate">{m.name}</span><span className="text-[11px] font-mono text-[#7a8a99]">M {m.mandanten_nr}{m.mandanten_nr === akt ? ' · aktuell gewählt' : ''}</span></span>
              <span className="text-[11px] text-[#7a8a99]">{m.akten.length} Akte{m.akten.length === 1 ? '' : 'n'}</span>
            </button>
            {m.akten.length > 0 && (
              <ul className="mt-3 divide-y divide-gray-100 border-t border-gray-100">{m.akten.map((a) => (
                <li key={a.case_id}><button type="button" onClick={() => oeffnen(m.mandanten_nr, a.case_id)} className="w-full flex items-center gap-2 py-2.5 text-left text-sm hover:text-[#b8893d] transition-colors" data-testid={`portal-mandat-akte-${a.case_id}`}>
                  <span className="font-mono text-xs text-[#1B3A5C] w-24 shrink-0">{a.aktenzeichen || '—'}</span>
                  <span className="flex-1 min-w-0 truncate text-[#34536b]">{a.rechtsgebiet}</span>
                  <span className="text-[11px] text-[#7a8a99]">{a.archived ? 'Archiviert' : STATUS[a.status] || a.status}</span>
                  <ChevronRight className="w-4 h-4 text-gray-300" />
                </button></li>))}</ul>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default AlleMandate;
